<template>
  <!-- 头部整体盒子 -->
  <div id="header" class="container-fuild">
    <!-- 电脑导航 -->
    <div class="header-nav container hidden-xs">
      <!-- 导航logo -->
      <div class="header-nav-logo" @click="handleClick()">
        <img src="@/assets/img/logo.png">
      </div>
      <!-- 导航内容 -->
      <ul class="header-nav-wrapper">
        <li
          v-for="(item,index) in navList"
          :key="index"
          :class="index==navIndex?'active':''"
        >
          <span class="nav-parent"  @click="handleNavClick(item, index)">
            {{item.name}}
            <span v-if="item.children.length>0" class="glyphicon glyphicon-menu-down"></span>
            <i class="underline"></i>
          </span>
          <!-- 子菜单 -->
          <dl v-if="item.children.length>0 && openIndex === index">
            <dt v-for="(i,n) in item.children" :key="n">
              <!-- 外部链接 -->
               <a v-if="i.externalUrl" :href="i.externalUrl" target="_blank" ref="noopenner noreferrer">{{i.name}}></a>
              <!-- 路由链接 -->
              <router-link v-else :to="i.path">{{i.name}}</router-link>
            </dt>
          </dl>
        </li>
        <div class="contact-sale" @click="handleContactSaleClick">
          联系销售
        </div>
        <div class="language-switch">
          <language-switch />
        </div>
      </ul>
    </div>
  </div>
</template>

<script>
import LanguageSwitch from '@/components/LanguageSwitch.vue'
export default {
  name: "Header",
  components: {
    LanguageSwitch,
  },
  data() {
    return {
      navIndex: sessionStorage.getItem('navIndex') ? sessionStorage.getItem('navIndex') : 0,
      menuName: "首页",
      menuClass: "glyphicon glyphicon-menu-down",
      // 添加下拉框显示状态管理
      openIndex: -1, // -1表示没有下拉框打开
      navList: [
        {
          name: "产品",
          path: "",
          children: [
            {
              name: "WhatsApp",
              path: "/product/whatsApp",
            },
            {
              name: "一次性验证码",
              path: "/product/OtpService",
            },
            {
              name: "营销短信",
              path: "/product/marketingSms",
            },
            {
              name: "号码筛选",
              path: "/product/numberFiltering",
            },
            {
              name: "预测式外呼",
              path: "/product/predictiveDiale",
            },
            {
              name: "话机服务",
              path: "/product/phone",
            },
            {
              name: "其它服务",
              path: "/product/ivr",
            },
          ]
        },
        {
          name: "资源中心",
          path: "/newsinformation",
          // externalLink:"https://web.antgst.com/privacy-policy",
          children: [
            {
              name: "API文档", 
              externalUrl: "https://doc.antgst.com/" // 外部链接子项
            }
          ]
        },
        {
          name: "关于我们",
          path: "/contactus",
          children: []
        }
      ]
    };
  },
  methods: {
    handleNavClick(item, index) {
      this.navIndex = index;
      sessionStorage.setItem('navIndex', index);
      this.menuName = item.name;
      
      // 有子菜单时才处理下拉框显示状态
      if (item.children && item.children.length > 0) {
      // 如果点击的是当前打开的下拉框，则关闭；否则打开
      this.openIndex = this.openIndex === index ? -1 : index;
      } else {
      // 没有子菜单时关闭所有下拉框
      this.openIndex = -1;
      // 如果该导航项没有子菜单，则跳转
      if (!item.children || item.children.length === 0) {
        if (item.path && this.$route.path !== item.path) {
          this.$router.push(item.path);
        }
      }
    }
    },
    menuClick() {
      if (this.menuClass == "glyphicon glyphicon-menu-down") {
        this.menuClass = "glyphicon glyphicon-menu-up";
      } else {
        this.menuClass = "glyphicon glyphicon-menu-down";
      }
    },
    handleClick() {
      this.$router.push('/')
    },
    handleContactSaleClick() {
      const currentPath = this.$route.path;
      if (currentPath === '/contactSale') {
        // 当前已经在目标页，刷新页面
        window.scrollTo(0, 0);
      } else {
        // 否则跳转
        this.$router.push('/contactSale');
      }
    }
  },
  mounted() {
    // 点击外部区域关闭下拉框
    this.handleClickOutside = (e) => {
      const navWrapper = this.$el.querySelector('.header-nav-wrapper');
      if (navWrapper && !navWrapper.contains(e.target)) {
        this.openIndex = -1;
      }
    };
    
    // 页面滚动时关闭下拉框
    this.handleScroll = () => {
      this.openIndex = -1;
    };
    
    document.addEventListener('click', this.handleClickOutside);
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy() {
    // 移除事件监听，避免内存泄漏
    document.removeEventListener('click', this.handleClickOutside);
    window.removeEventListener('scroll', this.handleScroll);
  }
};
</script>
<style scoped>
/* === 顶部导航整体盒子 === */
#header {
  background: #fff;
  position: fixed;
  top: 0px;
  width: 100%;
  height: 80px;
  z-index: 1000;
  box-shadow: 0 2px 8px rgba(0,0,0,0.05);
}

/* === logo样式 === */
.header-nav-logo {
  float: left;
  display: flex;
  align-items: center;
  height: 80px;
}
.header-nav-logo img {
  height: 70px;
}

/* === 主导航（电脑） === */
.header-nav-wrapper {
  float: right;
  display: flex;
  align-items: center;
  height: 80px;
  list-style: none;
  margin: 0;
  padding: 0;
}
.header-nav-wrapper .contact-sale {
  margin-left: 200px;
  margin-right: 40px;
  width:120px;
  height: 45px;
  border-radius: 40px;
  font-size: 20px;
  font-weight: 550;
  font-family: "Microsoft YaHei", "PingFang SC", sans-serif;
  color: #24936E;
  border: 1px solid #2aaf83;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: all 0.4s ease; /* 添加过渡效果 */
}
.header-nav-wrapper .contact-sale:hover {
  background-color: #24936E;
  color: white;
  font-weight: 550;
  cursor: pointer;
}
.header-nav-wrapper li {
  position: relative;
  margin: 0 18px;
}
/* 在下拉菜单和主菜单之间创建更大的悬停区域 */
.header-nav-wrapper li::after {
  content: '';
  position: absolute;
  bottom: -10px;
  left: 0;
  width: 100%;
  height: 20px;
  background: transparent;
  z-index: 999;
  
}

.header-nav-wrapper li > a {
  color: #333;
  font-size: 20px;
  font-weight: 550;
  position: relative;
  padding: 6px 0;
  transition: color 0.3s;
  text-decoration: none;
}

.header-nav-wrapper li > a:hover {
  color: #24936E;
}

/* 下划线动画 */
.header-nav-wrapper li > a > .underline {
  position: absolute;
  bottom: -2px;
  left: 50%;
  width: 0;
  height: 2px;
  background-color: #24936E;
  opacity: 0;
  transition: all 0.3s ease;
}

.header-nav-wrapper li:hover .underline {
  left: 0;
  width: 100%;
  opacity: 1;
}

/* 小图标旋转 */
.header-nav-wrapper li > a span {
  font-size: 12px;
  margin-left: 4px;
  transition: transform 0.3s;
}
.header-nav-wrapper li:hover > a span {
  transform: rotate(180deg);
}

/* 激活项 */
.header-nav-wrapper li.active > a {
  color: #24936E;
   /* 去掉下划线 */
  text-decoration: none;
}

/* === 二级菜单样式 === */
/* === 二级菜单样式（还原版）=== */
.header-nav-wrapper li dl {
  position: absolute;
  top: 100%; /* 从父菜单底部开始 */
  left: 0;
  background: white;
  box-shadow: 0 4px 12px rgba(0,0,0,0.08);
  border-radius: 6px;
  padding: 10px 0;
  display: none;
  min-width: 160px;
  z-index: 1001;
  pointer-events: none;
  opacity: 0;
  transition: opacity 0.3s ease, transform 0.3s ease;
  transform: translateY(10px);
}

.header-nav-wrapper li:hover dl {
  display: block;
  opacity: 1;
  pointer-events: auto;
  transform: translateY(0);
}

.header-nav-wrapper li dl dt {
  padding: 10px 20px;
  transition: background-color 0.2s ease;
}

.header-nav-wrapper li dl dt a,
.header-nav-wrapper li dl dt .router-link {
  font-size: 18px;
  color: #333;
  display: block;
  text-decoration: none;
}

.header-nav-wrapper li dl dt:hover {
  background-color: #f6f6f6;
}

.header-nav-wrapper li dl dt a:hover,
.header-nav-wrapper li dl dt .router-link:hover {
  color: #24936E;
  text-decoration: none;
}

/* 适配新结构（主菜单不跳转）*/
.header-nav-wrapper li > span.nav-parent {
  /* 保持与原来<a>标签相同的样式 */
  color: #333;
  font-size: 20px;
  font-weight: 550;
  position: relative;
  padding: 6px 0;
  display: inline-block;
  cursor: default; /* 主菜单不跳转，改为默认光标 */
}

.header-nav-wrapper li:hover > span.nav-parent {
  color: #24936E; /* 保持悬停颜色不变 */
}

/* === 移动端样式 === */
@media screen and (max-width: 997px) {
  .header-nav-m {
    background: #fff;
    padding: 10px;
  }

  .header-nav-m-logo img {
    height: 45px;
  }

  .header-nav-m-menu {
    background: #24936E;
    color: white;
    padding: 12px;
    position: relative;
  }

  .header-nav-m-menu-wrapper {
    position: absolute;
    right: 16px;
    top: 50%;
    transform: translateY(-50%);
    font-size: 16px;

  }

  .header-nav-m-wrapper {
    background: #f9f9f9;
    width: 100%;
  }

  .header-nav-m-wrapper li {
    border-bottom: 1px solid #eaeaea;
    padding: 12px;
  }

  .header-nav-m-wrapper li a {
    color: #333;
    font-weight: 500;
    text-decoration: none;
  }

  .header-nav-m-wrapper li.active a {
    color: #24936E;
  }
}
/* 在 Header 的 style 中添加 */
.ant-dropdown {
  z-index: 1005 !important; /* 确保高于其他元素 */
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue